import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import StandardModal from 'components/consumer/StandardModal';
import IconReturns from 'components/icons/iconReturns';
import IconMaterialsDesigned from 'components/icons/iconMaterialsDesigned';
import IconCalendar from 'components/icons/iconCalendar';
import IconDeliveryFlat from 'components/icons/iconDeliveryFlat';
import IconClock from 'components/icons/IconClock';
import iconPremiumDelivery from 'components/icons/iconPremiumDelivery';
import IconAffirmLogo from 'components/icons/iconAffirmLogo';
import { intersection } from 'lodash';
import Placeholder from 'components/consumer/Placeholder';
import PDPValuePropsModal from './PDPValuePropsModal';
export const convertPolicyToArray = policy => policy.replace('Unlimited furniture delivery for one flat fee', 'Unlimited flat rate shipping').replace('Free Returns within 14 days of receipt', '14-Day Returns').replace('14-Day Returns', '14-day returns').replace('Free Returns', '90-Day Returns').replace('90-Day Returns', '90-day returns').replace('30-Day Returns', '30-day returns').replace('365-Day Home Trial', '')
// https://stitchindustries.atlassian.net/browse/CON-7203
// replace 90 and 14 day returns with affirm popup due to return policy changes
.replace('90-day returns', 'Financing as low as 0% APR').replace('14-day returns', 'Financing as low as 0% APR').replace('Unlimited flat rate shipping', 'Premium In-Home Delivery').replace(/- /g, '').split(/\n|\r/).filter(Boolean);
const getValueProps = (type, fields, efgFlag, isExternal, hideReturns, hideUnlimitedShipping, campaign) => {
  const items = [];
  if (fields && fields.description_2) {
    const valueProps = convertPolicyToArray(fields.description_2);
    // ref: https://stitchindustries.atlassian.net/browse/CN-1003
    valueProps.forEach(value => {
      if (value.includes('Financing as low as 0% APR')) {
        items.push({
          id: 'AFFIRM_FINANCING',
          icon: IconAffirmLogo,
          value: value.trim(),
          width: 23
        });
      } else if (value.includes('Premium In-Home Delivery')) {
        if (!hideUnlimitedShipping) {
          items.push({
            id: 'PREMIUM_IN_HOME_DELIVERY',
            icon: iconPremiumDelivery,
            value: value.trim(),
            width: 34,
            height: 34
          });
        }
      } else if (value.includes('flat rate')) {
        if (!hideUnlimitedShipping) {
          items.push({
            id: 'FLAT_FEE',
            icon: IconDeliveryFlat,
            value: value.trim(),
            width: 23
          });
        }
      } else if (value.includes('30-day returns')) {
        if (hideReturns === false) {
          items.push({
            id: 'THIRTY_DAYS_RETURNS',
            icon: IconReturns,
            value: value.trim(),
            width: 26
          });
        }
      } else if (value.includes('90-day returns')) {
        if (hideReturns === false) {
          items.push({
            id: 'NINETY_DAYS_RETURNS',
            icon: IconReturns,
            value: value.trim(),
            width: 26
          });
        }
      } else if (value.includes('Difficulty:Limited Lifetime Warranty')) {
        items.push({
          id: 'LIFETIME_DIFFICULTY',
          icon: IconMaterialsDesigned,
          value: 'Limited lifetime warranty',
          width: 20
        });
      } else if (value.includes('Outdoor:Limited Lifetime Warranty')) {
        items.push({
          id: 'LIFETIME_OUTDOOR',
          icon: IconMaterialsDesigned,
          value: 'Limited warranty',
          width: 20
        });
      } else if (value.includes('CaseGoods:Limited Lifetime Warranty') || value.includes('DiningChairs:Limited Lifetime Warranty')) {
        items.push({
          id: 'LIFETIME_CASE_GOODS',
          icon: IconMaterialsDesigned,
          value: 'Limited warranty',
          width: 20
        });
      } else if (value.toLowerCase().includes('14 days') || value.toLowerCase().includes('14-day')) {
        if (hideReturns === false) {
          // CON-2378: show 90 days for all EFG-Internal
          if (efgFlag) {
            if (!isExternal) {
              if (value.includes('14-day returns')) {
                items.push({
                  id: 'DAY_14_RETURNS',
                  icon: IconReturns,
                  value: '14-day returns',
                  width: 24
                });
              } else {
                items.push({
                  id: 'NINETY_DAYS_RETURNS',
                  icon: IconReturns,
                  value: '90-day returns',
                  width: 26
                });
              }
            } else {
              items.push({
                id: 'DAY_14_RETURNS',
                icon: IconReturns,
                value: '14-day returns',
                width: 26
              });
            }
          } else {
            items.push({
              id: 'DAY_14_RETURNS',
              icon: IconReturns,
              value: value.trim(),
              width: 26
            });
          }
        }
      } else if (value.includes('Final sale')) {
        items.push({
          id: 'FINAL_SALE',
          icon: IconCalendar,
          value: value.trim(),
          width: 24
        });
      }
    });
  }
  if (campaign === 'barbie') {
    items.push({
      id: 'LIMITED_EDITION',
      icon: IconClock,
      value: 'Limited Edition',
      width: 26
    });
  }
  return items;
};
const PDPKeySellingPointsUI = t0 => {
  const $ = _c(21);
  const {
    type,
    fields,
    efg_flag,
    is_external,
    category_ids,
    difficulty,
    showClearanceWarning,
    loading,
    campaign
  } = t0;
  const [valueProps, setValueProps] = useState(null);
  const [activePanel, setActivePanel] = useState(null);
  const shouldHideUnlimitedShippingByCategoryId = _temp;
  const shouldHideShippingAndReturnsForFabric = _temp2;
  let t1;
  let t2;
  if ($[0] !== campaign || $[1] !== category_ids || $[2] !== difficulty || $[3] !== efg_flag || $[4] !== fields || $[5] !== is_external || $[6] !== loading || $[7] !== showClearanceWarning || $[8] !== type) {
    t1 = () => {
      if (!loading) {
        let hideUnlimitedShipping = category_ids ? shouldHideUnlimitedShippingByCategoryId(category_ids) : false;
        const hideShippingAndReturnsForFabric = type ? shouldHideShippingAndReturnsForFabric(type.name) : false;
        hideUnlimitedShipping = hideShippingAndReturnsForFabric === true ? true : hideUnlimitedShipping;
        const hideReturns = hideShippingAndReturnsForFabric === true ? true : !!showClearanceWarning;
        const applyProductWarrantyPolicy = theFields => {
          const theseFields = {
            ...theFields
          };
          const difficultyList = ["A", "B", "C", "D", "E", "F", "CUBE"];
          const matchDiningChairCategories = intersection([247], category_ids);
          const matchOutdoorCategories = intersection([624, 625, 626, 627, 628, 629], category_ids);
          const ignoreDecorCategory = intersection([222], category_ids);
          if (efg_flag && is_external) {
            return theseFields;
          }
          if (Array.isArray(ignoreDecorCategory) && ignoreDecorCategory.length > 0) {
            if (theseFields.description_2 && /- Free Returns/.test(theseFields.description_2)) {
              theseFields.description_2 = theseFields.description_2.replace(/- Free Returns/, "Free Returns within 14 days of receipt");
            }
            return theseFields;
          }
          if (theseFields.description_2) {
            if (difficultyList.indexOf(difficulty) > -1) {
              theseFields.description_2 = theseFields.description_2.replace("Limited Lifetime Warranty", "Difficulty:Limited Lifetime Warranty");
            } else {
              if (Array.isArray(matchDiningChairCategories) && matchDiningChairCategories.length > 0 && Array.isArray(matchOutdoorCategories) && matchOutdoorCategories.length > 0) {
                theseFields.description_2 = `${theseFields.description_2.trim()}\n - Outdoor:Limited Lifetime Warranty`;
              } else {
                if (Array.isArray(matchDiningChairCategories) && matchDiningChairCategories.length > 0) {
                  theseFields.description_2 = `${theseFields.description_2.trim()}\n - DiningChairs:Limited Lifetime Warranty`;
                } else {
                  if (Array.isArray(matchOutdoorCategories) && matchOutdoorCategories.length > 0) {
                    theseFields.description_2 = `${theseFields.description_2.trim()}\n - Outdoor:Limited Lifetime Warranty`;
                  } else {
                    theseFields.description_2 = `${theseFields.description_2.trim()}\n - CaseGoods:Limited Lifetime Warranty`;
                  }
                }
              }
            }
          }
          return theseFields;
        };
        const anotherValueProps = getValueProps(type, applyProductWarrantyPolicy(fields), efg_flag, is_external, hideReturns, hideUnlimitedShipping, campaign);
        setValueProps(anotherValueProps);
      }
    };
    t2 = [type, fields, loading, efg_flag, is_external, category_ids, showClearanceWarning, difficulty, campaign];
    $[0] = campaign;
    $[1] = category_ids;
    $[2] = difficulty;
    $[3] = efg_flag;
    $[4] = fields;
    $[5] = is_external;
    $[6] = loading;
    $[7] = showClearanceWarning;
    $[8] = type;
    $[9] = t1;
    $[10] = t2;
  } else {
    t1 = $[9];
    t2 = $[10];
  }
  useEffect(t1, t2);
  if (loading) {
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="flex flex-col justify-center mt-8 p-0 w-full"><ul className="items-center flex justify-center list-none m-0 p-0">{[0, 1, 2].map(_temp3)}</ul></div>;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    return t3;
  }
  let t3;
  if ($[12] !== valueProps) {
    t3 = valueProps?.map(item => <li className="items-center flex flex-col justify-center list-none m-0 p-0" key={`li${item.value}${item.id}`}><button type="button" key={item.value + item.id} data-xc={`PDPSellingPoint-${item.id}`} className="text-xs bg-transparent border-2 border-solid border-transparent cursor-pointer text-gray-light1 items-center flex flex-col px-2 py-0.5 m-0 text-center max-w-[33vw] !normal-case max-[767px]:flex-1 max-[767px]:leading-[unset] max-[767px]:p-0 max-[767px]:m-0 ml-5 last:mr-5 focus:text-brand hover:text-brand" onClick={() => {
        bb103: switch (item.id) {
          case "FLAT_FEE":
            {
              setActivePanel({
                id: item.id,
                title: "Contactless, flat-rate delivery",
                icon: item.icon
              });
              break bb103;
            }
          case "THIRTY_DAYS_RETURNS":
            {
              setActivePanel({
                id: item.id,
                title: "30-day returns",
                icon: item.icon
              });
              break bb103;
            }
          case "NINETY_DAYS_RETURNS":
            {
              setActivePanel({
                id: item.id,
                title: "90-day returns",
                icon: item.icon
              });
              break bb103;
            }
          case "DAY_14_RETURNS":
            {
              setActivePanel({
                id: item.id,
                title: "14-day returns",
                icon: item.icon
              });
              break bb103;
            }
          case "FINAL_SALE":
            {
              setActivePanel({
                id: item.id,
                title: "Final Sale",
                icon: item.icon
              });
              break bb103;
            }
          case "LIFETIME_CASE_GOODS":
          case "LIFETIME_OUTDOOR":
          case "LIFETIME_DINING_CHAIR":
            {
              setActivePanel({
                id: item.id,
                title: "Limited Warranty",
                icon: item.icon
              });
              break bb103;
            }
          case "LIFETIME_DIFFICULTY":
            {
              setActivePanel({
                id: item.id,
                title: "Limited lifetime warranty",
                icon: item.icon
              });
              break bb103;
            }
          case "LIMITED_EDITION":
            {
              setActivePanel({
                id: item.id,
                title: "Limited Edition",
                icon: item.icon
              });
              break bb103;
            }
          case "AFFIRM_FINANCING":
            {
              setActivePanel({
                id: item.id,
                title: "As low as 0% APR with Affirm",
                icon: item.icon
              });
              break bb103;
            }
          case "PREMIUM_IN_HOME_DELIVERY":
            {
              setActivePanel({
                id: item.id,
                title: "Premium In-Home Delivery",
                icon: item.icon
              });
              break bb103;
            }
          default:
        }
      }}><div className="flex items-center justify-center mb-2"><item.icon aria-hidden="true" color="currentColor" height={item?.height ?? 26} width={item.width} /></div><span className="max-[767px]:max-w-[90px]">{item.value}<sup>*</sup></span></button></li>);
    $[12] = valueProps;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t3) {
    t4 = <ul className="items-center flex justify-center list-none m-0 p-0">{t3}</ul>;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== activePanel) {
    t5 = activePanel && <StandardModal isOpen={true} dataXc="PDPSellingPointDialog" title={activePanel?.title} icon={<div className="[&_g]:stroke-[#fff]"><activePanel.icon width={25} height={30} color="#ffffff" /></div>} onClose={() => {
      setActivePanel(null);
    }}><PDPValuePropsModal itemId={activePanel.id} /></StandardModal>;
    $[16] = activePanel;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t4 || $[19] !== t5) {
    t6 = <div className="flex flex-col justify-center mt-8 p-0 w-full">{t4}{t5}</div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
PDPKeySellingPointsUI.propTypes = {
  loading: PropTypes.bool,
  type: PropTypes.shape({
    name: PropTypes.string
  }),
  efg_flag: PropTypes.number,
  difficulty: PropTypes.string,
  is_external: PropTypes.number,
  category_ids: PropTypes.arrayOf(PropTypes.number),
  fields: PropTypes.shape({
    anchor_link: PropTypes.string,
    background: PropTypes.string,
    block_padding: PropTypes.string,
    description_1: PropTypes.string,
    description_2: PropTypes.string,
    title_1: PropTypes.string,
    title_2: PropTypes.string
  }),
  showClearanceWarning: PropTypes.bool,
  campaign: PropTypes.string
};
export default PDPKeySellingPointsUI;
function _temp(categoryIds) {
  return categoryIds && categoryIds.includes(222);
}
function _temp2(productType) {
  return productType && productType === "Fabric";
}
function _temp3(idx) {
  return <li className="items-center flex flex-col justify-center list-none m-0 p-0" key={`PDPKeySellingPointsUI__item${idx}`}><div className="text-xs bg-transparent border-2 border-solid border-transparent cursor-pointer text-gray-light1 items-center flex flex-col px-2 py-0.5 m-0 text-center max-w-[33vw] !normal-case max-[767px]:flex-1 max-[767px]:leading-[unset] max-[767px]:p-0 max-[767px]:m-0 ml-5 last:mr-5 focus:text-brand hover:text-brand [&_span]:max-[767px]:max-w-[90px]"><div className="flex items-center justify-center mb-2"><Placeholder type="round" loading={true} style={{
          height: "36px",
          width: "36px"
        }} /></div><span className="max-[767px]:max-w-[90px]"><Placeholder type="rect" loading={true} style={{
          height: "12px",
          width: "120px"
        }} /></span></div></li>;
}